import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext } from 'react';
import { BaseCalendarContext } from '@libs/@core/components/date-picker/BaseCalendar';
import { monthNames } from '@libs/@core/components/date-picker/utils/dateUtils';
import { isEndMonth, isSelectedMonth, isStartMonth } from '@libs/@core/components/date-picker/utils/monthUtils';
var BaseCalendarMonthContent = function (_a) {
    var selectedDate = _a.selectedDate, currentDate = _a.currentDate;
    var _b = useContext(BaseCalendarContext), multiple = _b.multiple, handleSelectMonth = _b.handleSelectMonth;
    return (_jsx("div", { className: 'grid grid-cols-3 gap-2 w-[250px]', children: monthNames.map(function (month, index) {
            var monthDate = new Date(currentDate.getFullYear(), index, 1); // Tạo đối tượng tháng
            // Kiểm tra trạng thái của tháng được chọn
            var isSelected = Array.isArray(selectedDate)
                ? isSelectedMonth(monthDate, selectedDate) ||
                    isStartMonth(monthDate, selectedDate) ||
                    isEndMonth(monthDate, selectedDate)
                : isSelectedMonth(monthDate, selectedDate);
            var selectRange = Array.isArray(selectedDate)
                ? "".concat(isStartMonth(monthDate, selectedDate) ? 'rounded-l-md !bg-primary-main' : '', " ").concat(isEndMonth(monthDate, selectedDate) ? 'rounded-r-md !bg-primary-main' : '')
                : '';
            return (_jsx("div", { onClick: function () { return handleSelectMonth(index); }, className: "cursor-pointer h-10 w-full flex items-center justify-center text-sm focus:outline-none focus:ring-2 focus:ring-primary ".concat(selectRange, " ").concat(isSelected
                    ? "".concat(multiple ? 'bg-blue-300' : 'bg-primary-main rounded-md', "  text-white")
                    : 'hover:bg-gray-100 text-gray-700'), children: month }, month));
        }) }));
};
export default memo(BaseCalendarMonthContent);
